export const menus = [
  {
    id: "users",
    label: "USERS",
    icon: "users",
    items: [
      {
        label: "USER LIST",
        icon: "list",
        to: "/app/users",
        page: "Create User",
      },
      // {
      //   label: "CREATE CUSTOMER",
      //   icon: "customer",
      //   to: "/app/customers",
      //   page: "Create Customer",
      // },
      // {
      //   label: "CREATE TRANSPORTER",
      //   icon: "truck",
      //   to: "/app/transporters",
      //   page: "Create Transporter",
      // },
      // {
      //   label: "LOGIN LIST",
      //   icon: "truck",
      //   to: "/app/login-list",
      //   page: "Create Transporter",
      // },
      {
        label: "DEVICE ACCESS",
        icon: "truck",
        to: "/app/device-access",
        page: "Create Transporter",
      },
    ],
  },
  {
    id: "sales",
    label: "SALES & PURCHASES",
    icon: "cart",
    items: [
      {
        label: "SALES INVOICES",
        icon: "list",
        to: "/app/sales-invoices",
        page: "Sales Invoice",
      },
      // {
      //   label: "CREATE INVOICE",
      //   icon: "list",
      //   to: "/app/sales-invoices/create",
      //   page: "Sales Invoice",
      // },
      // {
      //   label: "CREATE CHALLAN",
      //   icon: "list",
      //   to: "/app/sales-invoices",
      //   page: "Sales Invoice",
      // },
      // {
      //   label: "SALES ORDER",
      //   icon: "list",
      //   to: "/app/sales-orders",
      //   page: "Sales Order",
      // },
      // {
      //   label: "COMPLETED ORDER",
      //   icon: "list",
      //   to: "/app/complete-orders",
      //   page: "Complete Order",
      // },
      {
        label: "SALES FLOW",
        icon: "list",
        to: "/app/sales-flow",
        page: "Cancelled Order",
      },
      {
        label: "CREDIT NOTE",
        icon: "list",
        to: "/app/credit-note",
        page: "CreditNote",
      },
      {
        label: "SALES LEAD",
        icon: "list",
        to: "/app/sales-leads",
        page: "Sales Lead",
      },
      {
        label: "PURCHASE FLOW",
        icon: "list",
        to: "/app/purchase-flow",
        page: "Target Creation",
      },
      {
        label: "TARGET FLOW",
        icon: "list",
        to: "/app/target-tabs",
        page: "Target Creation",
      },
      {
        label: "GSM Calculator",
        icon: "list",
        to: "/app/gsm-calculator",
        page: "Target Creation",
      },
      // {
      //   label: "TARGETS",
      //   icon: "list",
      //   to: "/app/targets",
      //   page: "Target Creation",
      // },
      // {
      //   label: "CUSTOMER TARGETS",
      //   icon: "list",
      //   to: "/app/customer-targets",
      //   page: "Customer Target Creation",
      // },
      // {
      //   label: "SALES PERSON TARGETS",
      //   icon: "list",
      //   to: "/app/salesperson-targets",
      //   page: "Salesperson Target",
      // },
      // {
      //   label: "TARGETS ACHIEVED",
      //   icon: "list",
      //   to: "/app/target-achieved",
      //   page: "Target Achieved",
      // },
      {
        label: "PROMOTIONAL ACTIVITY",
        icon: "list",
        to: "/app/promotional-activity",
        page: "Promotional Activity",
      },
      { label: "DEBIT NOTE", icon: "list", to: "/app/sales/debit-note" },
      { label: "CREDIT NOTE", icon: "list", to: "/app/sales/credit-note" },
    ],
  },
  // {
  //   id: "purchase",
  //   label: "PURCHASE",
  //   icon: "cart",
  //   items: [
  //     {
  //       label: "PURCHASE ORDER",
  //       icon: "list",
  //       to: "/app/purchase-orders",
  //       page: "Purchase Order",
  //     },
  //     {
  //       label: "PENDING PURCHASE",
  //       icon: "list",
  //       to: "/app/pending-purchase",
  //       page: "Purchase Pending",
  //     },
  //     {
  //       label: "PURCHASE RETURN",
  //       icon: "list",
  //       to: "/app/purchase-return",
  //       page: "Purchase Return",
  //     },
  //     {
  //       label: "PURCHASE INVOICE",
  //       icon: "list",
  //       to: "/app/purchase-invoice",
  //       page: "Purchase Invoice",
  //     },
  //     {
  //       label: "DEBIT NOTE",
  //       icon: "list",
  //       to: "/app/debit-note",
  //       page: "Debit Notes",
  //     },
  //   ],
  // },
  {
    id: "transaction",
    label: "TRANSACTION",
    icon: "tx",
    items: [
      {
        label: "RECEIPT",
        icon: "list",
        to: "/app/receipts",
        page: "Receipt",
      },
      // {
      //   label: "PAYMENTS",
      //   icon: "list",
      //   to: "/app/payments",
      //   page: "Payment",
      // },
      // {
      //   label: "CASHBOOK",
      //   icon: "list",
      //   to: "/app/cashbook",
      //   page: "Cashbook",
      // },
      // {
      //   label: "LEDGER",
      //   icon: "list",
      //   to: "/app/ledger",
      //   page: "Party Ledger",
      // },
      // { label: "LEDGER", icon: "list", to: "/app/txn/ledger" },
      // { label: "BANK STATEMENT", icon: "list", to: "/app/txn/bank-statement" },
    ],
  },
  {
    id: "report",
    label: "REPORT",
    icon: "report",
    items: [
      // { label: "GSTR 1", icon: "list", to: "/app/gstr1", page: "GSTR 1" },
      // { label: "GSTR 3B", icon: "list", to: "/app/gstr3b", page: "GSTR 3B" },
      // { label: "GSTR 2B", icon: "list", to: "/app/gstr2b", page: "GSTR 2B" },
      // {
      //   label: "HSN WISE REPORT",
      //   icon: "list",
      //   to: "/app/hsn-wise-report",
      //   page: "HSN WISE REPORT",
      // },
      {
        label: "GST Reports",
        icon: "list",
        to: "/app/gst-reports",
        page: "HSN WISE REPORT",
      },
      {
        label: "Purchase Reports",
        icon: "list",
        to: "/app/purchase-reports",
        page: "PRODUCT WISE PURCHASE REPORT",
      },
      {
        label: "Stock Reports",
        icon: "list",
        to: "/app/stock-reports",
        page: "Low Stock",
      },
      {
        label: "Sales Reports",
        icon: "list",
        to: "/app/sales-reports",
        page: "PARTY WISE AND PRODUCT WISE SALE REPORT",
      },
      {
        label: "Finance Reports",
        icon: "list",
        to: "/app/finance-reports",
        page: "PARTY WISE AND PRODUCT WISE SALE REPORT",
      },
      {
        label: "Books Of Account Reports",
        icon: "list",
        to: "/app/books-of-account-flow",
        page: "PARTY WISE AND PRODUCT WISE SALE REPORT",
      },
      // {
      //   label: "PRODUCT WISE PURCHASE REPORT",
      //   icon: "list",
      //   to: "/app/product-wise-purchase-report",
      //   page: "",
      // },
      // {
      //   label: "PURCHASE ORDER REPORT",
      //   icon: "list",
      //   to: "/app/product-order-report",
      //   page: "PURCHASE ORDER REPORT",
      // },
      // {
      //   label: "PARTY WISE AND PRODUCT WISE PURCHASE REPORT",
      //   icon: "list",
      //   to: "/app/purchase-report-amount",
      //   page: "PARTY WISE AND PRODUCT WISE PURCHASE REPORT",
      // },
      // {
      //   label: "INWARD STOCK",
      //   icon: "list",
      //   to: "/app/inward-stock",
      //   page: "Inward Stock",
      // },
      // {
      //   label: "OUTWARD STOCK",
      //   icon: "list",
      //   to: "/app/outward-stock",
      //   page: "Outward Stock",
      // },
      // {
      //   label: "LOW STOCK",
      //   icon: "list",
      //   to: "/app/low-stock",
      //   page: "Low Stock",
      // },
      // {
      //   label: "DAMAGED STOCK",
      //   icon: "list",
      //   to: "/app/damaged-stock",
      //   page: "Damaged Stock",
      // },
      // {
      //   label: "OVERDUE STOCK",
      //   icon: "list",
      //   to: "/app/overdue-stock",
      //   page: "OverDue Stock",
      // },
      // {
      //   label: "DEAD PARTY",
      //   icon: "list",
      //   to: "/app/dead-party",
      //   page: "Dead Party",
      // },
      // {
      //   label: "STOCK DIFFERENCE",
      //   icon: "list",
      //   to: "/app/stock-diff",
      //   page: "STOCK DIFFERENCE REPORT",
      // },
      // {
      //   label: "DEAD STOCK",
      //   icon: "list",
      //   to: "/app/dead-stock",
      //   page: "Dead Stock Report",
      // },
    ],
  },
  // {
  //   id: "report2",
  //   label: "REPORTS",
  //   icon: "report",
  //   items: [
  // {
  //   label: "CLOSING STOCK",
  //   icon: "list",
  //   to: "/app/closing-stock",
  //   page: "Closing Stock Report",
  // },
  // {
  //   label: "SALES ORDER",
  //   icon: "list",
  //   to: "/app/sales-order-report",
  //   page: "Sales Order Report",
  // },
  // {
  //   label: "TARGET REPORT",
  //   icon: "list",
  //   to: "/app/target-report",
  //   page: "SalesTarget Report",
  // },
  // {
  //   label: "TAX REPORT",
  //   icon: "list",
  //   to: "/app/tax-report",
  //   page: "TAX REPORT",
  // },
  // {
  //   label: "LOCK PARTY",
  //   icon: "list",
  //   to: "/app/lock-party-report",
  //   page: "Lock Party Report",
  // },
  // {
  //   label: "BANK STATEMENT REPORT",
  //   icon: "list",
  //   to: "/app/bank-statement-report",
  //   page: "Bank Statement",
  // },
  // {
  //   label: "PROFIT AND LOSS REPORT",
  //   icon: "list",
  //   to: "/app/profit-loss-report",
  //   page: "Profit and Loss Report",
  // },
  // {
  //   label: "PROMOTIONAL ACTIVITY REPORT",
  //   icon: "list",
  //   to: "/app/promotional-activity-report",
  //   page: "Promotional Activity Report",
  // },
  // {
  //   label: "DAMAGE STOCK REPORT WAREHOUSE",
  //   icon: "list",
  //   to: "/app/damaged-stock-report",
  //   page: "Damage Report",
  // },
  // {
  //   label: "WASTAGE REPORT WAREHOUSE",
  //   icon: "list",
  //   to: "/app/wastage-report",
  //   page: "Wastage Detail",
  // },
  // {
  //   label: "GST INPUT & OUTPUT",
  //   icon: "list",
  //   to: "/app/gst-input-output-report",
  //   page: "Wastage Detail",
  // },
  //   ],
  // },
  {
    id: "production",
    label: "PRODUCTION",
    icon: "cart",
    items: [
      {
        label: "ITEMS",
        icon: "list",
        to: "/app/production-items",
        page: "Items",
      },
      {
        label: "PRODUCT SECTION",
        icon: "list",
        to: "/app/production-product-section",
        page: "Raw Products",
      },
      {
        label: "RAW PRODUCTS",
        icon: "list",
        to: "/app/raw-product",
        page: "Raw Products",
      },
      {
        label: "PRODUCTION MANAGEMENT",
        icon: "list",
        to: "/app/start-production",
        page: "Start Production",
      },
    ],
  },
  {
    id: "setup",
    label: "Setup",
    icon: "report",
    items: [
      {
        label: "WAREHOUSE LIST",
        icon: "list",
        to: "/app/warehouses",
        page: "Warehouse",
      },
      {
        label: "STOCK TRANSFER",
        icon: "list",
        to: "/app/stock-transfer",
        page: "Stock Transfer",
      },
      {
        label: "PRODUCT FIELD CREATION",
        icon: "list",
        to: "/app/categories",
        page: "Category List",
      },
      { label: "UNIT LIST", icon: "list", to: "/app/units", page: "Units" },
      { label: "HSN LIST", icon: "list", to: "/app/hsn" },
      {
        label: "PRODUCTION STEPS",
        icon: "list",
        to: "/app/production-steps",
        page: "Production Steps",
      },
      {
        label: "PRODUCT LIST",
        icon: "list",
        to: "/app/products",
        page: "Product Creation",
      },
      {
        label: "PRICE LIST",
        icon: "list",
        to: "/app/price-list",
        page: "Price List",
      },
      { label: "ACCOUNT LIST", icon: "list", to: "/app/accounts", page: "" },
      {
        label: "DEPARTMENT ROLE ASSIGNMENT",
        icon: "list",
        to: "/app/roles",
        page: "Assign Team",
      },
      {
        label: "Assign Team Member",
        icon: "list",
        to: "/app/assign-team-member",
        page: "Assign Team",
      },
      {
        label: "CUSTOMER GRADE LIST",
        icon: "list",
        to: "/app/grades",
        page: "Create Grade",
      },
      {
        label: "DEPARTMENT LIST",
        icon: "list",
        to: "/app/departments",
        page: "Create Department",
      },
      {
        label: "ASSIGN PINCODE",
        icon: "list",
        to: "/app/assign-pincode",
        page: "Assign SalesPerson Area",
      },
      {
        label: "CHARGES",
        icon: "list",
        to: "/app/charges",
        page: "Add Charges",
      },
      {
        label: "EXPENSE ACCOUNTS",
        icon: "list",
        to: "/app/expense-account",
        page: "Expense Accounts",
      },
    ],
  },
];
